// extracted by mini-css-extract-plugin
export var header = "header-module--header--4dQNe";
export var headerTrigger = "header-module--header-trigger--GQD+9";
export var headerWrapper = "header-module--header-wrapper--ggfd+";
export var social = "header-module--social---fo7o";
export var wood = "header-module--wood---2qq8";